import { render, staticRenderFns } from "./ProgramItemPoster.vue?vue&type=template&id=0133ae28&scoped=true&"
import script from "./ProgramItemPoster.vue?vue&type=script&lang=js&"
export * from "./ProgramItemPoster.vue?vue&type=script&lang=js&"
import style0 from "./ProgramItemPoster.vue?vue&type=style&index=0&id=0133ae28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0133ae28",
  null
  
)

export default component.exports